import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AppProfile } from '@app/core/enums/app-profile.enum';
import { LoggerService } from '@app/core/services/logger.service';
import { SaveObjectInLocalServiceService } from '@app/core/services/save-object-in-local-service.service';
const logger = new LoggerService('AppProfileDirective');

@Directive({
  selector: '[dhlAppProfile]'
})
export class AppProfileDirective {
  private currentProfile!: AppProfile;
  private profileToValidate!: AppProfile;

  constructor(private readonly templateRef: TemplateRef<unknown>, private readonly viewContainer: ViewContainerRef, private readonly storage: SaveObjectInLocalServiceService) {
    logger.debug(this.storage.getObject('profile') as string);
    this.currentProfile = this.storage.getObject('profile') as AppProfile;
  }

  ngOnInit() {
    logger.debug(this.storage.getObject('profile') as string);
    this.currentProfile = this.storage.getObject('profile') as AppProfile;
  }

  @Input()
  set dhlAppProfile(profile: AppProfile) {
    this.profileToValidate = profile;
    this.updateView();
  }

  private updateView() {
    if (this.currentProfile === this.profileToValidate) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
